import { TParamContext } from "./ParamContext";
export const paramSelectFn = (data: Record<string, string | string[]>) => {
  const { paramNames, paramValues } = data;
  return [...paramNames].reduce((obj, currentParamName, idx) => {
    return {
      ...obj,
      [currentParamName]: paramValues[idx]
    };
  }, {} as TParamContext);
};